import { Stack } from '@mui/material';
import { Address, IAddress } from './Address';
import { ContactDetails } from './ContactDetails';
import { useIsDesktop } from 'Hooks';
import { MobileContactDetails } from './MobileContactDetails';
import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { OpenClose } from '../OpenClose';

interface IContactInformation {
  data: ISuppliersResult;
  isOpen: boolean;
  setIsOpen: Function;
  isAlwaysOpen?: boolean;
  hasDetailsData: boolean;
}

export const ContactInformation = ({
  data,
  isOpen,
  setIsOpen,
  isAlwaysOpen,
  hasDetailsData,
}: IContactInformation) => {
  const isDesktop = useIsDesktop();

  const addresses: {
    firstAddress: IAddress;
    secondAddress: IAddress;
  } = {
    firstAddress: {
      street: data.firstStreet,
      houseNumber: data.firstHouseNumber,
      cityId: data.firstCityId,
    },
    secondAddress: {
      street: data.secondStreet,
      houseNumber: data.secondHouseNumber,
      cityId: data.secondCityId,
    },
  };

  const contacts = {
    cellPhoneNumber:
      data.cellPhonePrefix && data.cellPhoneNumber
        ? `${data.cellPhonePrefix}-${data.cellPhoneNumber}`
        : null,
    homePhoneNumber:
      data.homePhonePrefix && data.homePhoneNumber
        ? `${data.homePhonePrefix}-${data.homePhoneNumber}`
        : null,
    email: data.email,
  };

  return (
    <Stack direction={isDesktop ? 'row' : 'column'}>
      <Address
        addresses={addresses}
        coordinates={{
          firstLatitude: data.firstLatitude,
          firstLongitude: data.firstLongitude,
          secondLatitude: data.secondLatitude,
          secondLongitude: data.secondLongitude,
        }}
      />
      {isDesktop ? (
        <ContactDetails contacts={contacts} />
      ) : (
        <MobileContactDetails contacts={contacts} />
      )}
      {isAlwaysOpen ? null : isDesktop || !isOpen ? (
        <OpenClose
          isOpen={isOpen}
          hasDetailsData={hasDetailsData}
          setIsOpen={() => setIsOpen(!isOpen)}
        />
      ) : null}
    </Stack>
  );
};
